import { Fragment, useCallback } from 'react';
import {
    Element,
    Image,
    Level,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import { IBreadcrumb, IBreadCrumbItem } from '@zmedia/bm-soccer-ui/interface';
import styles from './style.module.scss';

interface IProps {
    breadcrumb: IBreadcrumb;
}

export const BreadCrumb = ({ breadcrumb }: IProps) => {
    const { left = [], right = [] } = breadcrumb;

    const renderItems = useCallback((items: IBreadCrumbItem[] = []) => {
        return items.map((item: IBreadCrumbItem, index: number) => {
            let isH1 = false;
            if (index === items.length - 1) {
                isH1 = true;
            }
            return (
                <Fragment key={`breadcrumb.${index}`}>
                    {item.html ? (
                        <Element
                            dangerouslySetInnerHTML={{ __html: item.html }}
                        />
                    ) : (
                        <>
                            <RouterLink
                                to={item.url}
                                className={styles['item']}
                                style={item.styles || {}}
                                title={item.name}
                            >
                                {item.logo && (
                                    <Image
                                        src={item.logo}
                                        alt={item.name}
                                    ></Image>
                                )}
                                {isH1 ? (
                                    <Element renderAs="h1">{item.name}</Element>
                                ) : (
                                    <>{item.name}</>
                                )}
                            </RouterLink>
                        </>
                    )}
                </Fragment>
            );
        });
    }, []);

    return (
        <Level className={styles['breadcrumb']}>
            <Level.Side align="left">{renderItems(left)}</Level.Side>
            <Level.Side align="right">{renderItems(right)}</Level.Side>
        </Level>
    );
};
